import React from "react";
import { Panel } from "@xyflow/react";

export default function EmptyStateOverlay() {
  return (
    <Panel position="top-center" className="board-editor-empty-state">
      <div className="board-editor-empty-state-inner">
        <p className="board-editor-empty-state-title">
          Drag a device from the knowledge base to start building.
        </p>
        <p className="board-editor-empty-state-hint">
          Or <a href="/featured" className="board-editor-empty-state-link">browse featured rigs</a> for a head start.
        </p>
        <p className="board-editor-empty-state-note">
          No sign up needed to play around.
        </p>
      </div>
    </Panel>
  );
}
